import { DeviceInfo } from "../../../../Device/Info/DeviceInfo";
import { IDisposable } from "../../../../Global/Base/IDisposable";
import { Key } from "../../../../Global/Base/Utils/EventUtils";
import { Localization } from "../../../../OW.Remoting/Remoting/Localization";
import { Control as BaseControl } from "../../../UI.BaseControls/Control";
import { IValidatableContainer } from "../../../UI.BaseControls/ControlInterfaces";
import { IBooleanDetailValueEventData } from "../../../UI.BaseControls/IEvent";
import { ElementUtils } from "../../../UI.ElementarControls/Helpers/ElementUtils";
import { registerCustomElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { loadOriginalRightsDefinition } from "../../Rights/OriginalRightsDefinitionLoader";
import { AlignPanelWidthCounter, helper } from "../AlignPanelWidthCounter";
import { Control } from "../Controls/Control";
import { ControlParams, IHTMLElementWithControl } from "../Controls/ControlInterfaces";
import { FormManager } from "../FormManager/IFormManager";
import { UIManager } from "../UIManager";
import { DetailFrame } from "./DetailFrame";

export class Pages extends Control {
    //#region Fields
    public static tabsColored: string[] = ["color1", "color2", "color3", "color4", "color5", "color6", "color7"];
    public static lastTabColorIndex: number = 0;
    public tabArray: Array<PageTab>;
    public pageArray: Array<Page>;
    public selectedTab: PageTab;
    public tabsDivContainer: HTMLElement; // kontejner okolo seznamu zalozek
    public tabsList: HTMLElement; // seznam zalozek

    public tabsSelect: HTMLSelectElement;
    public tabsSelectIcon: HTMLElement;
    public overflowTabIndex = 1000;
    public parentDetailFrame: DetailFrame;
    public parentAlignPanelElement: HTMLElement;

    private _showTabStrip: boolean = false;
    private _listenerFocus: EventListener;
    private _listenerBlur: EventListener;
    private _listenerChange: EventListener;
    //#endregion Fields

    //#region Constructors
    constructor(params: ControlParams) {
        super(params);

        this.element.classList.add("Pages");

        const showTabStrip = this.getDataAttr("showtabstrip");
        this._showTabStrip = showTabStrip == null ? true : showTabStrip.toLowerCase() == "true";

        const pageList: NodeList = this.element.querySelectorAll(":scope > div[data-tsccontrol='Page']");

        const parentsDetails = $(this.element).parents("[data-tsccontrol$=\"DetailFrame\"]");
        if (parentsDetails.length > 0) {
            this.parentDetailFrame = (parentsDetails[0] as IHTMLElementWithControl).tscControl as DetailFrame;
        }
        this.parentAlignPanelElement = $(this.element).parents(".counted[data-tsccontrol=\"AlignPanel\"]")[0];

        if (pageList.length > 0) {
            this.pageArray = new Array<Page>();
            this.tabArray = new Array<PageTab>();

            if (this._showTabStrip) {
                this.tabsDivContainer = document.createElement("div"); // element kvuli ostylovani Tab kontejneru
                this.tabsDivContainer.classList.add("tabsDivContainer");

                this.tabsList = document.createElement("ul");
                this.tabsList.classList.add("tabsList");
                this.tabsDivContainer.appendChild(this.tabsList);

                this.element.insertBefore(this.tabsDivContainer, this.element.firstChild);
            }
            this._initTabs(pageList);

            if (this._showTabStrip) {
                const devProps = DeviceInfo.deviceProperties;

                // iOS a Android - vyber zalozek v selectu
                if (devProps.touch && (devProps.iOS || devProps.android)) {
                    this.tabsSelectIcon = document.createElement("span");
                    this.tabsSelectIcon.classList.add("icon");

                    if (devProps.iOS) {
                        this.tabsSelectIcon.textContent = "\uF15C";
                    }
                    if (devProps.android) {
                        this.tabsSelectIcon.textContent = "^";
                        this.tabsSelectIcon.classList.add("tab"); // sipka ma vypadat jako tab
                    }

                    this.tabsList.appendChild(this.tabsSelectIcon);

                    this.tabsSelect = document.createElement("select");
                    // this.tabsList.appendChild(this.tabsSelect); /*removePhoneStyles*/

                    this.tabsSelect.addEventListener("focus", this._listenerFocus = () => {
                        if (devProps.iOS) {
                            this.tabsSelectIcon.textContent = "\uF15D";
                        }
                        if (devProps.android) {
                            this.tabsSelectIcon.classList.add("active");
                        }
                    });

                    this.tabsSelect.addEventListener("blur", this._listenerBlur = () => {
                        this._inactivateIcon();
                    });

                    this.tabsSelect.addEventListener("change", this._listenerChange = () => {
                        this.tabArray[this.overflowTabIndex + this.tabsSelect.selectedIndex].pageTabClick();
                        this._inactivateIcon();
                    });

                    this.setEventMethods();
                }
            }
            /* //vyhazuje chybu "Cannot read property 'pageYOffset' of null"
            if (!devProps.Touch) {
                $(this.tabsList).sortable({   // prehazovani zalozek
                    cursor: 'move',
                    helper: "clone",
                    distance: 10
                });
            }*/
        }
    }
    //#endregion Constructors

    //#region Methods
    public setEventMethods(): void {
        const devProps = DeviceInfo.deviceProperties;

        if (devProps.touch && (devProps.iOS || devProps.android)) {
            FormManager.instance.formOpened.add(this._checkTabsEventMethodWithTimeout);
            UIManager.instance.windowResized.add(this.checkTabsEventMethod);
            this.parentDetailFrame?.frameIsVisible.add(this.checkTabsEventMethod);
        }
    }

    public static getColor(): string {
        const color = Pages.tabsColored[Pages.lastTabColorIndex++];

        if (Pages.lastTabColorIndex >= Pages.tabsColored.length) {
            Pages.lastTabColorIndex = 0;
        }

        return color;
    }

    /** Nastavi ikonu pro vyber zalozek na neaktivni */
    private _inactivateIcon(): void {
        if (DeviceInfo.deviceProperties.iOS) {
            this.tabsSelectIcon.textContent = "\uF15C";
        }
        if (DeviceInfo.deviceProperties.android) {
            this.tabsSelectIcon.classList.remove("active");
        }
    }

    /** Inicializuje zalozky */
    private _initTabs(pageList: NodeList): void {
        for (let i: number = 0; i < pageList.length; i++) {
            const pageElement = pageList[i] as HTMLElement;
            const pageOriginalRightsDefinition = loadOriginalRightsDefinition(pageElement);
            const page: Page = new Page({ element: pageElement, originalRightsDefinition: pageOriginalRightsDefinition });

            page.setVisibility(false);
            this.pageArray.push(page);

            const tab: PageTab = new PageTab(i, this, page);
            tab.isShown = false;

            page.tab = tab;

            if (this._showTabStrip) {
                this.tabsList.appendChild(tab.tab);
                Localization.addLocData(tab.tab, page.LocKey, Localization.TEXT_CONTENT, "title");
            }

            this.tabArray.push(tab);

            if (i === 0) {
                tab.pageTabClick();
            }
        }
    }

    /** Akce pro window resize */
    public checkTabsEventMethod = () => {
        this._checkTabs();
    };

    /** Akce pro zobrazeni formulare - timeout kvuli prohlizeci, at ma cas zobrazit html elementy */
    private _checkTabsEventMethodWithTimeout = () => {
        self.setTimeout(() => {
            this._checkTabs();
        }, 200);
    };

    /** checknuti preteceni zalozek pro mobily */
    private _checkTabs(): void {
        if (!this.tabArray || !this._showTabStrip)
            return;

        const visibleTabs = this.tabArray.filter((tab) => tab.isShown); // vsechny viditelne pages

        if (visibleTabs.length) {
            // zviditelneni vsech zalozek
            visibleTabs.forEach((tab, _index) => {
                tab.tab.style.display = "";
            });

            // odstraneni prebytecnych elementu (select, ikona) + nasetovani pevne sirky zalozkam - kvuli zjisteni preteceni
            this.tabsList.classList.remove("otherTabs");
            this.tabsList.classList.add("noflex");

            // preteceni
            if (this.tabsDivContainer.clientWidth < this.tabsDivContainer.scrollWidth) {
                // offset prvni zalozky
                const lOff = visibleTabs[0].tab.offsetLeft;

                // zjisteni pretekajicich zalozek
                for (let i = 1; i < visibleTabs.length; i++) {
                    const tab = visibleTabs[i].tab;
                    // 25 je sirka potrebna na select
                    if ((tab.offsetLeft - lOff) + tab.offsetWidth + 25 <= this.tabsDivContainer.clientWidth) {
                        continue;
                    } else { // pretekajici zalozka
                        this.overflowTabIndex = i;
                        //overflow = true;
                        break;
                    }
                }

                if (this.tabsSelect != undefined) {
                    this.tabsSelect.innerHTML = "";
                    this.tabsList.classList.add("otherTabs");

                    const overflows = visibleTabs.filter((_tab, index) => {
                        return index >= this.overflowTabIndex;
                    });

                    // setovani select options
                    overflows.forEach((tab) => {
                        tab.tab.style.display = "none";
                        const opt = document.createElement("option");
                        this.tabsSelect.appendChild(opt);
                        Localization.addLocData(opt, tab.page.LocKey);
                    });

                    if (this.selectedTab.index >= this.overflowTabIndex)
                        this.tabsSelect.selectedIndex = this.selectedTab.index - this.overflowTabIndex;
                    else
                        this.tabsSelect.selectedIndex = -1;
                }
            }

            this.tabsList.classList.remove("noflex");
        }
    }
    //#endregion Methods

    //#region IDisposable
    //destruktor
    public override dispose(): void {
        if (this.tabsSelect != null) {
            this.tabsSelect.removeEventListener("focus", this._listenerFocus);

            this.tabsSelect.removeEventListener("blur", this._listenerBlur);
            this.tabsSelect.removeEventListener("change", this._listenerChange);
        }

        if (this.tabArray) {
            for (const tab of this.tabArray) {
                if (tab) {
                    tab.dispose();
                }
            }
            this.tabArray = [];
        }

        if (this.pageArray) {
            for (const page of this.pageArray) {
                if (page) {
                    page.dispose();
                }
            }
            this.pageArray = [];
        }

        super.dispose();
    }

    //#endregion IDisposable
}

/**
 * Reprezentuje obsah Page
 */
export class Page extends Control {
    public LocKey: string;
    public tab: PageTab;

    private _page: PageElement;

    constructor(params: ControlParams) {
        super(params);
        this._page = params.element as PageElement;
        // podle validnosti page se ridi i ousko zalozky
        this._page.addEventListener("validityChanged", () => {
            if (this.tab)
                this.tab.isValid = this._page.isValid;
        });
        this.LocKey = this._page.getAttribute("data-captionlockey");
    }

    //#region Properties
    public override set visible(value: boolean) {
        if (this._page == undefined)
            return;

        this._visible = value;

        if (!this.tab)
            return;

        if (value) {
            this.tab.isShown = true;
            const visibleUserSelected = this.tab.parent.tabArray.find(t => t.userSelected && t.isShown);
            if (visibleUserSelected) {
                if (visibleUserSelected === this.tab)
                    this.tab.pageTabClick();
            } else if (this.tab.index < this.tab.parent.selectedTab.index || this.tab.page.visible && !this.tab.parent.selectedTab.page.visible) {
                this.tab.pageTabClick();
            }
        } else {
            this.tab.isShown = false;
            if (this.tab.tab.className.indexOf("active") > -1) {
                for (let i = 0; i < this.tab.parent.tabArray.length; i++) {
                    if (this.tab.parent.tabArray[i].isShown) {
                        this.tab.parent.tabArray[i].pageTabClick();
                        break;
                    }
                }
            }
        }
    }

    public override get visible(): boolean {
        return this._visible;
    }

    public setVisibility(visible: boolean): void {
        if (this._page == undefined)
            return;

        if (visible)
            this._page.style.removeProperty("display");
        else
            this._page.style.display = "none";
    }

    public override dispose(): void {
        this.tab.dispose();
        super.dispose();
    }
}

interface PageElement {
    addEventListener(type: "validityChanged", listener: (ev: CustomEvent) => any, useCapture?: boolean): void;
    addEventListener(type: string, listener: EventListenerOrEventListenerObject, useCapture?: boolean): void;
}

class PageElement extends HTMLDivElement implements IValidatableContainer {
    public isContainer: boolean;

    public get isValid(): boolean {
        return !this.hasAttribute("invalid");
    }

    public set isValid(v: boolean) {
        if (v === this.isValid)
            return;

        ElementUtils.toggleAttribute(this, "invalid", !v);
        this.dispatchEvent(new CustomEvent("validityChanged"));
    }

    constructor(self?: any) {
        super();
        self ? self._constructor() : this._constructor(); // polyfill
    }

    protected _constructor(): void {
        this.isContainer = true;
        this.classList.add("Page");
    }
}

/**
 * Reprezentuje klikaci zalozku pro zobrazeni obsahu Page.
 */
export class PageTab implements IDisposable {
    public tab: HTMLElement;
    public parent: Pages;
    public page: Page;
    public index: number;
    private _color: string;
    private _isShown: boolean = false; // priznak jestli je Tab + Page skryta (podle podminky ShowIf)
    private _oldCanValueLoad: boolean; // pouziva se, aby se opakovane nevyvolavala udalost na aktualizaci hodnot v komponentach po zviditelneni zalozky
    private _userSelected: boolean = false;

    private _listenerClick: EventListener;
    private _listenerKeypress: EventListener;

    public set color(val: string) {
        this._color = val;
        /*if ($(this.Tab).is(":visible")) { // Pokud je zalozka viditelna uz pri nastavovani barvy, je treba ji predat nastaveni
            const ap = AlignPanelWidthCounter.getFirstAlignPanel(this.Page.Element);
            const lfs = <HTMLElementWithControl[]>Array.prototype.slice.call(ap.querySelectorAll('[data-tsccontrol="ListFrame"]'));
        }*/
    }

    public get color(): string {
        return this._color;
    }

    public get isValid(): boolean {
        return !this.tab.hasAttribute("invalid");
    }

    public set isValid(v: boolean) {
        ElementUtils.toggleAttribute(this.tab, "invalid", !v);
    }

    /** Příznak, zda byla záložka vybrána uživatelem */
    public get userSelected(): boolean {
        return this._userSelected;
    }

    constructor(index: number, parent: Pages, page: Page) {
        this.tab = document.createElement("li");
        this.tab.tabIndex = 0;
        this.tab.classList.add("tab");
        this.tab.addEventListener("click", this._listenerClick = (_evn) => {
            this.parent.tabArray.forEach(t => t._userSelected = false);
            this._userSelected = true;
            this.pageTabClick();
        });

        this.tab.addEventListener("keypress", this._listenerKeypress = (evn: KeyboardEvent) => {
            if ((evn.key === Key.Enter || evn.key === Key.Space)) { // enter nebo mezernik
                this.parent.tabArray.forEach(t => t._userSelected = false);
                this._userSelected = true;
                this.pageTabClick();
                evn.preventDefault();
            }
        });

        this.parent = parent;
        this.page = page;
        this.index = index;
    }

    /** Zobrazi zalozku */
    public activateTab(active: boolean): void {
        $(this.tab).toggleClass("active", active);
        this.page.setVisibility(active);
        this.tryTriggerCanValueLoadChange();
    }

    /** Nastavuje zobrazeni/skryti zalozky + page (podle podminky ShowIf) */
    public set isShown(isShown: boolean) {
        this._isShown = isShown;

        if (isShown) {
            this.tab.classList.remove("notShown");
            if (!this.parent.element.querySelector(".tab.active")) { // aktivace záložky, pokud žádná jiná není aktivní
                this.activateTab(true);
                this.parent.selectedTab = this;
            }
            if (this.tab.classList.contains("active")) {
                this.page.setVisibility(true);
                this.tryTriggerCanValueLoadChange();
            }
        } else {
            this.tab.classList.add("notShown");
            if (this.tab.classList.contains("active")) {
                this.activateTab(false);
                const visibleTab = this.parent.tabArray.find(tab => tab.isShown);
                if (visibleTab) { // aktivace první viditelné záložky
                    this.parent.selectedTab = visibleTab;
                    visibleTab.activateTab(true);
                }
            }
            this.page.setVisibility(false);
        }
    }

    /** Vraci stav skryti zalozky + page (podle podminky ShowIf) */
    public get isShown(): boolean {
        return this._isShown;
    }

    /** Pokud došlo ke změně vlastnosti _canValueLoad spustí se na potomcích event informující o změně možnosti dočítání dat.
     * Vrací informaci jestli došlo ke spuštění eventu. */
    public tryTriggerCanValueLoadChange(): boolean {
        const canValueLoad = this._canValueLoad;

        if (this._oldCanValueLoad === canValueLoad)
            return false;

        this._oldCanValueLoad = canValueLoad;
        const listOfElements = Array.from(this.page.element.querySelectorAll("[data-tsccontrol],.CustomControl")) as IHTMLElementWithControl[] | Control[];
        for (const element of listOfElements) {
            if (element instanceof BaseControl) { // pokud se jedna o CustomElement, je zavolana nativni událost
                const htcontrol = element as BaseControl;
                htcontrol.callEvent("canvalueload", { value: canValueLoad } as IBooleanDetailValueEventData);
            } else {
                const htcontrol: Control = (element as IHTMLElementWithControl).tscControl as Control;
                if (htcontrol && htcontrol.canValueLoadChanged)
                    htcontrol.tryTriggerCanValueLoadChange(htcontrol, htcontrol.canValueLoad);
            }
        }
        return true;
    }

    /**
     * Vrací true, pokud je komponenta v takovém stavu, že je možné do ní dočítat hodnoty.
     */
    private get _canValueLoad(): boolean {
        return this.tab.classList.contains("active") && this.isShown && ((this.page.element as IHTMLElementWithControl).tscControl as Control).canValueLoad;
    }

    /** Kliknuti na zalozku */
    public pageTabClick(): void {
        let firstSelect = false;

        if (!this.parent.selectedTab) { // prvni kliknuti na lib. tab
            firstSelect = true;
            this.parent.selectedTab = this;
        }

        if (this.parent.selectedTab != this || firstSelect) {
            this.parent.selectedTab.activateTab(false);
            this.parent.selectedTab = this;
            this.activateTab(true);

            if (this.parent.tabsSelect && this.index < this.parent.overflowTabIndex)
                this.parent.tabsSelect.selectedIndex = -1;

            // nastaveni column/fixed layout
            const ap = AlignPanelWidthCounter.getFirstAlignPanel(this.page.element);

            if (!ap)
                return;

            const requiredWidth = helper.getNumAttr(ap, "requiredWidth");
            const requiredHeight = helper.getNumAttr(ap, "requiredHeight");

            // page s formularem
            if (requiredWidth && requiredHeight) {
                // spusteni udalosti pro zobrazeni prvku (povoli aktualizaci dat)
                this.tryTriggerCanValueLoadChange();
                this.parent.parentAlignPanelElement.classList.remove("SlaveListFrameVisible");
            } else { // listframe
                this.tryTriggerCanValueLoadChange();
                this.parent.parentAlignPanelElement?.classList.add("SlaveListFrameVisible");
            }
        }
    }

    //destruktor
    public dispose(): void {
        if (this.tab) {
            this.tab.removeEventListener("click", this._listenerClick);
            this.tab.removeEventListener("keypress", this._listenerKeypress);
        }
    }
}

registerCustomElement("tsc-page", PageElement, "div");
